  // $(document).ready(function(){
  //   $('.carousel_cum').slick({
  //     slidesToShow: 4,
  //     slidesToScroll: 1,
  //     autoplay: false,
  //     arrows: true,
  //     dots: false,
  //     prevArrow: '<button type="button" class="slick-prev"><svg class="arrow-icon" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_167_5)"> <rect width="30" height="30" rx="15" fill="black"></rect> <path d="M8 14.5L17.1667 23L19 21.3L11.6667 14.5L19 7.7L17.1667 6L8 14.5Z" fill="white"></path></g> <defs> <clipPath id="clip0_167_5"> <rect width="30" height="30" rx="15" fill="white"></rect></clipPath></defs></svg></button>',
  //     nextArrow: '<button type="button" class="slick-next"><svg class="arrow-icon" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_167_5)"> <rect x="30" y="30" width="30" height="30" rx="15" transform="rotate(-180 30 30)" fill="black"></rect> <path d="M21 15.5L11.8333 7L10 8.7L17.3333 15.5L10 22.3L11.8333 24L21 15.5Z" fill="white"></path></g> <defs> <clipPath id="clip0_167_5"> <rect x="30" y="30" width="30" height="30" rx="15" transform="rotate(-180 30 30)" fill="white"></rect></clipPath></defs></svg></button>',
  //     responsive: [
  //       {
  //         breakpoint: 1024,
  //         settings: {
  //           slidesToShow: 4,
  //           slidesToScroll: 1
  //         }
  //       },
  //       {
  //         breakpoint: 768,
  //         settings: {
  //           slidesToShow: 4,
  //           slidesToScroll: 1
  //         }
  //       },
  //       {
  //         breakpoint: 480,
  //         settings: {
  //           slidesToShow: 4,
  //           slidesToScroll: 1
  //         }
  //       }
  //     ]
  //   });
  // });

jQuery(document).ready(function() {
    jQuery(document).on('click', '.swatch_options .swatch label', function(){
        console.log("sdfsdf");
        setTimeout(function() {
    
        if(jQuery('button[name="add"]').attr("disabled") == "disabled"){
            jQuery('button[name="add"] span').text("sold out");
        }else{
              jQuery('button[name="add"] span').text("Add to cart");
        }
            }, 1000);
    });
});


const sliderThumbnail = new Swiper('.slider-thumbnail', {
  slidesPerView: 4,
  spaceBetween: 10,
  freeMode: true,
  centerInsufficientSlides: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  navigation: {
    nextEl: '.next-slide',
    prevEl: '.prev-slide',
  }
});

var carousel = new Swiper('.product-image-slider', {
  loop: true,
  slidesPerView: 1,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  initialSlide: 0,
  thumbs: {
    swiper: sliderThumbnail
  }
}); 

$(document).ready(function() {
  $(".click_one_test").click(function(){
    $("div#first_logo_div").css("display","flex");
  });
  $('.figure.wrapping_content_comp, .comp_slider').wrap('<div class="slider_wrapper_cstm" />');
  if ($("body").hasClass("all-product-page") == true) {
    console.log(1);
  }
  else{
    if ($('.banner-inner-pages').length > 0) {
      $(document.body).addClass('banner_for_menus');
    }
  }
  if ($("body").hasClass("login") == true) {
    $(document.body).addClass('combine_pages_logo');
  }
  if ($("body").hasClass("cart") == true) {
    $(document.body).addClass('combine_pages_logo');
  }
  if ($("body").hasClass("register") == true) {
    $(document.body).addClass('combine_pages_logo');
  }
  if ($("body").hasClass("account") == true) {
    $(document.body).addClass('combine_pages_logo');
  }
  if ($("body").hasClass("blog") == true) {
    $(document.body).addClass('combine_pages_logo');
  }
  if ($("body").hasClass("Distributors") == true) {
    $(document.body).addClass('combine_pages_logo');
  }
  if ($("body").hasClass("Contact") == true) {
    $(document.body).addClass('combine_pages_logo');
  }
});

$(".main-nav__wrapper.gill_vivek_cstm").mouseover(function(){
  $(this).addClass("subHeadingHover");
});
$(".main-nav__wrapper.gill_vivek_cstm").mouseout(function(){
  $(this).removeClass("subHeadingHover");
});

$(document).on( "click", ".close_icon a.close_mini_cart", function() {
  $('body').removeClass('is-active').removeClass('blocked-scroll');
  $('.dropdown_link').toggleClass('active_link');
  $('.cart-container').removeClass('active_link');
});

$(".close_serach").click(function(){
  $(".cstm_wrap_system").removeClass('Show_search');  
});

$("p.search_icon_cstm.icon-search").click(function(){
  $(".cstm_wrap_system").toggleClass('Show_search'); 
});

$(document).on('click', '.text_href', function () {
  var new_url = $(this).attr('href');
  window.location.href = new_url;
});

jQuery( ".filter_icons_mobile" ).on( "click", function() {
  jQuery(".filter_sidebar.sidebar").toggleClass('show_filter_now');
});

jQuery(".sidebar-block__heading span.right").on("click", function() {
  setTimeout(function() {$(".sidebar-block[data-sidebar-block-animation='closed=>open'] span.right.icon-down-arrow.sidebar-block-toggle-icon").click();}, 500);
});

$(".cstm_collection_teplate .product_form form .swatch_options .swatch .swatch-element label").each(function(){

$(this).click(function(){
  $(".purchase-details.addtocart_cstm_select").removeClass('addtocart_cstm_select');
  $(this).parents(".swatch_options").prev().addClass('cstm_select');
  $(this).parents(".swatch_options").next().addClass('addtocart_cstm_select');
  var button_value=$(this).attr('df');
  var button_value_cstm=$.trim(button_value);
  console.log(button_value_cstm);
  console.log(1);
  $(".select.cstm_select select option").each(function(){
    var gggg=$(this).text();
    console.log(gggg);
    if(button_value_cstm==gggg){
      $(this).attr("selected","selected");
      $(this).siblings().removeAttr('selected');
      $(".purchase-details.addtocart_cstm_select .add_to_cart.ajax-submit").trigger('click');
      setTimeout(function() {$(".cart-container a.icon-cart.mini_cart").trigger('click');}, 1500);
    }     
  });
});   
});
$("#hundered_filter").click(function(){
  $(".price_range_one").val('0');
  $(".price_range_two").val('100');
  $(".cstm_btn_price").trigger('click');
});

$("#hud_twenty_filter").click(function(){
  $(".price_range_one").val('100');
  $(".price_range_two").val('220');
  $(".cstm_btn_price").trigger('click');
});

$("#twenty_two").click(function(){
  $(".price_range_one").val('220');
  $(".price_range_two").val('400');
  $(".cstm_btn_price").trigger('click');
});


$(".set > a").on("click", function() {
  if ($(this).hasClass("active")) {
    $(this).removeClass("active");
    $(this).siblings(".content").slideUp(200);
    $(".set > a i").removeClass("fas fa-chevron-up").addClass("fas fa-chevron-down");
  } else {
    $(".set > a i").removeClass("fas fa-chevron-up").addClass("fas fa-chevron-down");
    $(this).find("i").removeClass("fas fa-chevron-down").addClass("fas fa-chevron-up");
    $(".set > a").removeClass("active");
    $(this).addClass("active");
    $(".content").slideUp(200);
    $(this).siblings(".content").slideDown(200);
  }
});

$(".product-set > a").on("click", function() {
  if ($(this).hasClass("active")) {
    $(this).removeClass("active");
    $(this).siblings(".content").slideUp(200);
    $(".product-set > a i").removeClass("fa-solid fa-minus").addClass("fa-solid fa-plus");
  } else {
    $(".product-set > a i").removeClass("fa-solid fa-minus").addClass("fa-solid fa-plus");
      $(this).find("i").removeClass("fa-solid fa-plus").addClass("fa-solid fa-minus");
      $(".product-set > a").removeClass("active");
      $(this).addClass("active");
      $(".content").slideUp(200);
      $(this).siblings(".content").slideDown(200);
    }
  });
  
  $(".cstm_collection_teplate").each(function(){
    $(this).hover(function(){
      $(this).find('form').toggleClass('show_size');
      $(this).find('.swatch.is-flex.is-flex-wrap.Size').toggleClass('show_size');
    });
  });
  
  $(".mega-menu.menu.dropdown_content").each(function(){
    $(this).hover(function(){
      $("body").toggleClass('stop_scrolling');
    });
  });

  $(document).on('change', 'select.select__select_form_two', function() {
    var value_cstm=$(this).val();
    $(".product .inner_product .cstm_second_form .product-main .product_section .product__details form .swatch_options .Color input").each(function(){
      var new_ll=$(this).val();
      if(value_cstm==new_ll){
        $(this).click();
      }
    });
  });
  
  const modal = document.getElementById("myModal");
  const buttons = document.querySelectorAll(".text-size-chart");
  const span = document.querySelector(".close");
  buttons.forEach(button => {
    button.addEventListener("click", () => {
      modal.style.display = "block";
    });
  });
  
  span.addEventListener("click", () => {
    modal.style.display = "none";
  });
  
  window.addEventListener("click", (event) => {
    if (event.target === modal) {
      modal.style.display = "none";
    }
  });
  
  setTimeout(function() { 
    var urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.has("variant")) {
      var firstThumbnail = document.querySelector(".product_gallery_nav .gallery-cell:first-child img");
      if (firstThumbnail) {
        firstThumbnail.click();
      }
    }
  }, 800);
  
  setTimeout(function() { 
    $(".custom_slide_image_jv").css("opacity","1");
  }, 1500);
  
  $(".add_to_cart2").click(function(){
    setTimeout(function() {
      $("div#cart-total-price").load(location.href + " div#cart-total-price");
    }, 4500);
  });
  $(".mini-cart__item-content .product-quantity-box span.ss-icon.product-plus.js-change-quantity .icon-minus:before").click(function(){
    setTimeout(function() {
      $("div#cart-total-price").load(location.href + " div#cart-total-price");
    }, 2000);
  });
  
  $(".mini-cart__item-content .product-quantity-box span.ss-icon.product-plus.js-change-quantity .icon-plus:before").click(function(){
    setTimeout(function() {
      $("div#cart-total-price").load(location.href + " div#cart-total-price");
    }, 2000);
  });
  
  $(document).ready(function() {
    $(".swatch_options .swatch-element label").each(function(index) {
      $(this).click(function() {
        setTimeout(function() {
          $(".custm-section-size-help-text").load(location.href + " .custm-section-size-help-text");
        }, 100);
      });
    });
  });
  
  $(document).ready(function() {
    $('.custom-section-size-help').insertBefore(".purchase-details");
  });


  $(document).ready(function() {
    $('.details-content-text').insertAfter(".swatch.Size .option_title");
  });


  
  $("ul.cart_items.js-cart_items.fdfdf li.mini-cart__item a").click(function(){
    setTimeout(function() {
      $("div#cart-total-price").load(location.href + " div#cart-total-price");
    }, 3000);
  });
  
  $(".custom-sect-meta .purchase-details__buttons.purchase-details__spb--true button").click(function(){
    setTimeout(function() {
      $("div#cart-total-price").load(location.href + " div#cart-total-price");
    }, 3000);
  });

$('.product_variants select.color-selector').each(function() {
    var seen = {}; // Object to track seen option texts for each select element
    $(this).find('option').each(function() {
      var text = $(this).text(); // Get the text content of the current option
      if (seen[text]) {
        $(this).remove(); // Remove the option if the text is already seen
      } else {
        seen[text] = true; // Mark this text as seen
      }
    });
  });

$('.product_variants select.size-selector').each(function() {
    var seen = {}; // Object to track seen option texts for each select element
    $(this).find('option').each(function() {
      var text = $(this).text(); // Get the text content of the current option
      if (seen[text]) {
        $(this).remove(); // Remove the option if the text is already seen
      } else {
        seen[text] = true; // Mark this text as seen
      }
    });
  });


